import { Outlet, useParams } from 'react-router-dom';
import { ObservationProvider } from '@/lib/state/ObservationContext';

/**
 * Wraps all /observation/:observationId/* routes in an ObservationProvider
 * keyed by the URL so drafts hydrate from Dexie and autosave back.
 */
export function ObservationShell() {
  const { observationId } = useParams<{ observationId: string }>();
  return (
    <ObservationProvider observationId={observationId}>
      <Outlet />
    </ObservationProvider>
  );
}
